import {
    CheckboxProps,
    FormControlLabel,
    FormControlLabelProps,
    Checkbox as MUICheckbox,
    Skeleton,
} from '@mui/material';
interface ICheckboxProps extends CheckboxProps {
    labelProps: Omit<FormControlLabelProps, 'control'>;
    loading?: boolean;
}
const Checkbox = ({ labelProps, loading, ...checkboxProps }: ICheckboxProps) => (
    <FormControlLabel
        {...labelProps}
        disabled={loading || checkboxProps.disabled}
        control={
            loading ? (
                <Skeleton variant="rounded" width={20} height={20} className="m-[9px]" />
            ) : (
                <MUICheckbox {...checkboxProps} classes={{ disabled: 'opacity-[.12]', ...checkboxProps.classes }} />
            )
        }
    />
);
export { Checkbox };
